import { useLocale } from '../hooks/useLocale'
import { CountryFlags } from '../components/CountryFlags'
import styles from './Expertise.module.css'

interface ExpertiseItem {
  title: string
  countries: string[]
  description: string
  engagements: string[]
}

interface ExpertiseData {
  title: string
  engagementsLabel?: string
  items: ExpertiseItem[]
}

export default function Expertise() {
  const { get } = useLocale()
  const data = get('expertise') as ExpertiseData | undefined

  if (!data?.items?.length) return null

  return (
    <section className={styles.expertise} id="expertise" aria-labelledby="expertise-title">
      <div className={styles.container}>
        <h2 className={styles.title} id="expertise-title">
          {data.title}
        </h2>
        <div className={styles.grid}>
          {data.items.map((item, index) => (
            <article key={index} className={styles.card}>
              <div className={styles.cardHeader}>
                <h3 className={styles.cardTitle}>{item.title}</h3>
                <CountryFlags codes={item.countries} />
              </div>
              <p className={styles.description}>{item.description}</p>
              {item.engagements?.length > 0 && (
                <>
                  <h4 className={styles.engagementsTitle}>
                    {data.engagementsLabel ?? 'Typical engagements:'}
                  </h4>
                  <ul className={styles.engagements}>
                    {item.engagements.map((eng, i) => (
                      <li key={i}>{eng}</li>
                    ))}
                  </ul>
                </>
              )}
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
